export const CREDENTIAL_ACCOUNT_RESOURCE_KEY = 'credential-account-api';

export function createReducer(initialState, reducerMap) {
    return (state = initialState, action) => {
        const reducer = reducerMap[action.type];
        return reducer ? reducer(state, action.payload) : state;
    };
}
